export default __webpack_public_path__ + "static/media/typeb.c2235a42.png";